import type { ReactNode } from "react"

/**
 * OKS-548 — Today / Earlier section card (UX Spec §2).
 *
 * A rounded white card per group with a small uppercase muted label above
 * it; rows stack inside with hairline dividers (the row component draws
 * its own `border-b`). Renders nothing when the group is empty so a day
 * with only Earlier events hides the TODAY card (and vice-versa).
 */
export function ActivitySectionCard({
  label,
  testId,
  children,
  isEmpty,
}: {
  label: string
  testId: string
  children: ReactNode
  isEmpty: boolean
}) {
  if (isEmpty) return null

  return (
    <section data-testid={testId} className="flex flex-col gap-2">
      <h2 className="text-muted-foreground px-1 text-xs font-semibold tracking-wide uppercase">
        {label}
      </h2>
      <div className="bg-card overflow-hidden rounded-lg border">
        {children}
      </div>
    </section>
  )
}
